import { Dispatch, SetStateAction, useMemo } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Select from 'react-select';
import useThemeContext from '../../../../contexts/theme';
import { CustomStyle } from '../../../CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../CustomSelectStyleDarkTheme';
import FilterRadioButton from '../../../FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../FilterRadioButtonsContainer';
import FormGroup from '../../../FormGroup';
import MyModal from '../../../Modal';
import OpacityAnimation from '../../../OpacityAnimation';
import { ReactCalendarCustomStyle } from '../../../ReactCalendarCustomStyle';
import { Group, ModalContainer, MonthsGrid } from './styles';
import { OptionType } from './types';
import useDownloadGeneralReports from './useDownloadGeneralReports';

interface IDownloadOtimizationModal {
  downloadModalShow: boolean;
  setDownloadModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

export default function DownloadGeneralReportsModal({
  downloadModalShow,
  setDownloadModalShow,
  setIsLoading,
}: IDownloadOtimizationModal) {
  const {
    downloadReport,
    handleSpecificPeriodChange,
    specificPeriod,
    specificPeriodLabel,
    reportOptions,
    selectedReport,
    setSelectedReport,
    companiesOptions,
    selectedCompany,
    setSelectedCompany,
    filesBySelectedFileType,
    selectedFileType,
    setSelectedFileType,
    setSelectedFile,
    selectedFile,
    handleSpecificPeriodChangeMrReport,
    canDownloadReport,
    setPeriodBeingSelected,
    currentYear,
    periodBeingSelected,
    months,
    currentMonth,
    monthsMap,
    fileOptions,
    handleSelectedFileChange,
    partnersOptions,
    selectedPartner,
    setSelectedPartner,
    generatedConsultsReportType,
    setGeneratedConsultsReportType,
    baseFilesOptions,
    preAdmFilesOptions,
    isCustomer,
  } = useDownloadGeneralReports({
    setIsLoading,
    setDownloadModalShow,
    downloadModalShow,
  });

  const { selectedTheme } = useThemeContext();

  const jsxBySelectedReport: { [key: number]: JSX.Element  } = useMemo(() => ({
    60:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                  Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                  Período {specificPeriodLabel}
            </small>
          </Group>
        )}

        <Group>
          <div className="title">
                    Escolha o tipo do arquivo
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={selectedFileType === 'preAdm'} onClick={() => setSelectedFileType('preAdm')}>
                      Pré-Admissional
            </FilterRadioButton>
            <FilterRadioButton selected={selectedFileType === 'base'} onClick={() => setSelectedFileType('base')}>
                      Base
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
        {filesBySelectedFileType && filesBySelectedFileType?.length > 0 && (
          <>
            <Group>
              <div className="title">
                    Escolha o arquivo
              </div>
              <Select
                value={{ value: selectedFile?.value, label: selectedFile?.label }}
                options={[{
                  value: '', label: 'Selecione um Arquivo'
                }, ...filesBySelectedFileType]}
                onChange={(opt) => {
                  setSelectedFile({ value: opt!.value, label: opt!.label });
                }}
                styles={CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </Group>
          </>
        )}
      </>,
    601:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                  Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                  Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    600:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                  Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                  Período {specificPeriodLabel}
            </small>
          </Group>
        )}

        <Group>
          <div className="title">
                    Escolha o tipo do arquivo
          </div>
          <FilterRadioButtonsContainer>
            <FilterRadioButton selected={selectedFileType === 'preAdm'} onClick={() => setSelectedFileType('preAdm')}>
                      Pré-Admissional
            </FilterRadioButton>
            <FilterRadioButton selected={selectedFileType === 'base'} onClick={() => setSelectedFileType('base')}>
                      Base
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
        </Group>
        {filesBySelectedFileType && filesBySelectedFileType?.length > 0 && (
          <>
            <Group>
              <div className="title">
                    Escolha o arquivo
              </div>
              <Select
                value={{ value: selectedFile?.value, label: selectedFile?.label }}
                options={[{
                  value: '', label: 'Selecione um Arquivo'
                }, ...filesBySelectedFileType]}
                onChange={(opt) => {
                  setSelectedFile({ value: opt!.value, label: opt!.label });
                }}
                styles={CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </Group>
          </>
        )}
      </>,
    6010:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                  Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                  Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    503:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                  Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                  Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    61:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
              Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChangeMrReport} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChangeMrReport} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                Período {specificPeriodLabel}
            </small>
          </Group>
        )}

        {filesBySelectedFileType && filesBySelectedFileType?.length > 0 && (
          <>
            <Group>
              <div className="title">
                  Escolha o tipo do arquivo
              </div>
              <FilterRadioButtonsContainer>
                <FilterRadioButton selected={selectedFileType === 'preAdm'} onClick={() => setSelectedFileType('preAdm')}>
                    Pré-Admissional
                </FilterRadioButton>
                <FilterRadioButton selected={selectedFileType === 'base'} onClick={() => setSelectedFileType('base')}>
                    Base
                </FilterRadioButton>
              </FilterRadioButtonsContainer>
            </Group>

            <Group>
              <div className="title">
                  Escolha o arquivo
              </div>
              <Select
                value={{ value: selectedFile?.value, label: selectedFile?.label }}
                options={[{
                  value: '', label: 'Selecione um Arquivo'
                }, ...filesBySelectedFileType]}
                onChange={(opt) => {
                  setSelectedFile({ value: opt!.value, label: opt!.label });
                }}
                styles={CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </Group>
          </>
        )}
      </>,
    62:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <div className='modal-body-centered'>
            <div className="year-selection" style={{ marginTop: '8px'}}>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear) - 2
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear) - 2}
              >
                {String(Number(currentYear) - 2)}
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear) - 1
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear) - 1}
              >
                {String(Number(currentYear) - 1)}
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear)
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear)}
              >
                {currentYear}
              </FilterRadioButton>
            </div>
            <MonthsGrid>
              {months.map((month) => (
                <FilterRadioButton
                  key={month}
                  onClick={() => setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    month,
                  }))}
                  selected={month == periodBeingSelected.month}
                  invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                >
                  {monthsMap[month]}
                </FilterRadioButton>
              ))}
            </MonthsGrid>
            <FormGroup>
              <label htmlFor="contactName">Selecione o arquivo</label>
              <Select
                value={selectedFile}
                options={fileOptions}
                onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                placeholder="Selecionar Arquivo"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          </div>
        )}
      </>,
    52:
      <>
        <div className='modal-body-centered'>
          {!isCustomer && (
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                onClick={() => setGeneratedConsultsReportType('all')}
                selected={generatedConsultsReportType === 'all'}
              >
              Geral
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => setGeneratedConsultsReportType('byCompany')}
                selected={generatedConsultsReportType === 'byCompany'}
              >
              Por Empresa
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => setGeneratedConsultsReportType('byPartner')}
                selected={generatedConsultsReportType === 'byPartner'}
              >
              Por Parceiro
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          )}
          <div className="year-selection" style={{ marginTop: '8px'}}>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelected.month}
                invisible={currentYear === periodBeingSelected.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>

          {generatedConsultsReportType === 'byPartner' && !isCustomer && (
            <FormGroup>
              <label htmlFor="contactName">Selecione o Parceiro</label>
              <Select
                value={selectedPartner}
                options={partnersOptions}
                onChange={(prt) => setSelectedPartner(prt as OptionType)}
                placeholder="Selecionar Parceiro"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          )}

          {generatedConsultsReportType === 'byCompany' && !isCustomer && (
            <FormGroup>
              <label htmlFor="contactName">Empresa</label>
              <Select
                value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
                options={[{
                  value: '', label: 'Selecione uma Empresa'
                }, ...companiesOptions]}
                onChange={(opt) => {
                  setSelectedCompany({ value: opt!.value, label: opt!.label });
                }}
                styles={CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
                isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
              />
            </FormGroup>
          )}
        </div>
      </>,
    55:
      <>
        <div className='modal-body-centered'>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              onClick={() => setGeneratedConsultsReportType('all')}
              selected={generatedConsultsReportType === 'all'}
            >
              Geral
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => setGeneratedConsultsReportType('byPartner')}
              selected={generatedConsultsReportType === 'byPartner'}
            >
              Por Parceiro
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
          <div className="year-selection" style={{ marginTop: '8px'}}>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelected.month}
                invisible={currentYear === periodBeingSelected.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>

          {generatedConsultsReportType === 'byPartner' && (
            <FormGroup>
              <label htmlFor="contactName">Selecione o Parceiro</label>
              <Select
                value={selectedPartner}
                options={partnersOptions}
                onChange={(prt) => setSelectedPartner(prt as OptionType)}
                placeholder="Selecionar Parceiro"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          )}
        </div>
      </>,
    550:
      <>
        <div className='modal-body-centered'>
          <FilterRadioButtonsContainer>
            <FilterRadioButton
              onClick={() => setGeneratedConsultsReportType('all')}
              selected={generatedConsultsReportType === 'all'}
            >
              Geral
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => setGeneratedConsultsReportType('byPartner')}
              selected={generatedConsultsReportType === 'byPartner'}
            >
              Por Parceiro
            </FilterRadioButton>
          </FilterRadioButtonsContainer>
          <div className="year-selection" style={{ marginTop: '8px'}}>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelected.month}
                invisible={currentYear === periodBeingSelected.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>

          {generatedConsultsReportType === 'byPartner' && (
            <FormGroup>
              <label htmlFor="contactName">Selecione o Parceiro</label>
              <Select
                value={selectedPartner}
                options={partnersOptions}
                onChange={(prt) => setSelectedPartner(prt as OptionType)}
                placeholder="Selecionar Parceiro"
                styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </FormGroup>
          )}
        </div>
      </>,
    50:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    509:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    5011:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    5021:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    5:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    59:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
            isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
                          Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
                          Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    57:
    <Group>
      <div className="title">
          Período
      </div>
      {selectedTheme === 'dark' ? (
        <ReactCalendarCustomStyle>
          <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
        </ReactCalendarCustomStyle>
      ) : (
        <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
      )}
      <small>
          Período {specificPeriodLabel}
      </small>
    </Group>,
    571:
    <>
      <FormGroup>
        <label htmlFor="contactName">Empresa</label>
        <Select
          value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
          options={[{
            value: '', label: 'Selecione uma Empresa'
          }, ...companiesOptions]}
          onChange={(opt) => {
            setSelectedCompany({ value: opt!.value, label: opt!.label });
          }}
          styles={CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container"
          isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
        />
      </FormGroup>
      {selectedCompany.value && (
        <Group>
          <div className="title">
            Período
          </div>
          {selectedTheme === 'dark' ? (
            <ReactCalendarCustomStyle>
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            </ReactCalendarCustomStyle>
          ) : (
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
          )}
          <small>
            Período {specificPeriodLabel}
          </small>
        </Group>
      )}
    </>,
    504:
    <>
      <Group>
        <div className="title">
            Período
        </div>
        {selectedTheme === 'dark' ? (
          <ReactCalendarCustomStyle>
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
          </ReactCalendarCustomStyle>
        ) : (
          <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
        )}
        <small>
            Período {specificPeriodLabel}
        </small>
      </Group>
    </>,
    572:
    <>
      <Group>
        <div className="title">
            Período
        </div>
        {selectedTheme === 'dark' ? (
          <ReactCalendarCustomStyle>
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
          </ReactCalendarCustomStyle>
        ) : (
          <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
        )}
        <small>
            Período {specificPeriodLabel}
        </small>
      </Group>
    </>,
    501:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={preAdmFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    5019:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={preAdmFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    5012:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={preAdmFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    5022:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={preAdmFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    502:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={baseFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    5029:
        <>
          <Group>
            <div className="title">
                  Empresa
            </div>
            <Select
              value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
              options={[{
                value: '', label: 'Selecione uma Empresa'
              }, ...companiesOptions]}
              onChange={(opt) => {
                setSelectedCompany({ value: opt!.value, label: opt!.label });
              }}
              styles={CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
              isDisabled={selectedReport.value === 62 && generatedConsultsReportType !== 'byCompany'}
            />
          </Group>
          {selectedCompany.value && (
            <div className='modal-body-centered'>
              <div className="year-selection" style={{ marginTop: '8px'}}>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 2
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 2}
                >
                  {String(Number(currentYear) - 2)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear) - 1
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      year: Number(currentYear)
                    }));
                  }}
                  selected={periodBeingSelected.year == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setPeriodBeingSelected((prevState) => ({
                      ...prevState,
                      month,
                    }))}
                    selected={month == periodBeingSelected.month}
                    invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
              <FormGroup>
                <label htmlFor="contactName">Selecione o arquivo</label>
                <Select
                  value={selectedFile}
                  options={baseFilesOptions}
                  onChange={(fl) => handleSelectedFileChange(fl as OptionType)}
                  placeholder="Selecionar Arquivo"
                  styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </FormGroup>
            </div>
          )}
        </>,
    701:
      <>
        <Group>
          <div className="title">
            Período
          </div>
          {selectedTheme === 'dark' ? (
            <ReactCalendarCustomStyle>
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            </ReactCalendarCustomStyle>
          ) : (
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
          )}
          <small>
            Período {specificPeriodLabel}
          </small>
        </Group>
      </>,
    702:
      <>
        <Group>
          <div className="title">
            Período
          </div>
          {selectedTheme === 'dark' ? (
            <ReactCalendarCustomStyle>
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange />
            </ReactCalendarCustomStyle>
          ) : (
            <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange />
          )}
          <small>
            Período {specificPeriodLabel}
          </small>
        </Group>
      </>,
    703:
      <>
        <Group>
          <div className="title">
            Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
          />
        </Group>
        {selectedCompany.value && (
          <Group>
            <div className="title">
              Período
            </div>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar onChange={handleSpecificPeriodChange} value={specificPeriod} selectRange maxDate={new Date()} />
            )}
            <small>
              Período {specificPeriodLabel}
            </small>
          </Group>
        )}
      </>,
    521:
      <>
        <div className='modal-body-centered'>
          <div className="year-selection" style={{ marginTop: '8px'}}>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 2
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 2}
            >
              {String(Number(currentYear) - 2)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear) - 1
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear) - 1}
            >
              {String(Number(currentYear) - 1)}
            </FilterRadioButton>
            <FilterRadioButton
              onClick={() => {
                setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  year: Number(currentYear)
                }));
              }}
              selected={periodBeingSelected.year == Number(currentYear)}
            >
              {currentYear}
            </FilterRadioButton>
          </div>
          <MonthsGrid>
            {months.map((month) => (
              <FilterRadioButton
                key={month}
                onClick={() => setPeriodBeingSelected((prevState) => ({
                  ...prevState,
                  month,
                }))}
                selected={month == periodBeingSelected.month}
                invisible={currentYear === periodBeingSelected.year && month > currentMonth}
              >
                {monthsMap[month]}
              </FilterRadioButton>
            ))}
          </MonthsGrid>
          <FormGroup>
            <label htmlFor="contactName">Selecione o Parceiro</label>
            <Select
              value={selectedPartner}
              options={partnersOptions}
              onChange={(prt) => setSelectedPartner(prt as OptionType)}
              placeholder="Selecionar Parceiro"
              styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
              classNamePrefix="react-select"
              className="react-select-container"
            />
          </FormGroup>
        </div>
      </>,
    704:
      <>
        <Group>
          <div className="title">
            Período
          </div>
          <div className='modal-body-centered'>
            <div className="year-selection" style={{ marginTop: '8px'}}>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear) - 2
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear) - 2}
              >
                {String(Number(currentYear) - 2)}
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear) - 1
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear) - 1}
              >
                {String(Number(currentYear) - 1)}
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => {
                  setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    year: Number(currentYear)
                  }));
                }}
                selected={periodBeingSelected.year == Number(currentYear)}
              >
                {currentYear}
              </FilterRadioButton>
            </div>
            <MonthsGrid>
              {months.map((month) => (
                <FilterRadioButton
                  key={month}
                  onClick={() => setPeriodBeingSelected((prevState) => ({
                    ...prevState,
                    month,
                  }))}
                  selected={month == periodBeingSelected.month}
                  invisible={currentYear === periodBeingSelected.year && month > currentMonth}
                >
                  {monthsMap[month]}
                </FilterRadioButton>
              ))}
            </MonthsGrid>
            <small style={{ marginTop: '8px' }}>
              Período {`01/${String(periodBeingSelected.month).padStart(2, '0')}/${periodBeingSelected.year} até ${String(new Date(periodBeingSelected.year, periodBeingSelected.month, 0).getDate()).padStart(2, '0')}/${String(periodBeingSelected.month).padStart(2, '0')}/${periodBeingSelected.year}`}
            </small>
          </div>
        </Group>
      </>,
    604:
      <>
        <Group>
          <div className="title">
                Empresa
          </div>
          <Select
            value={{ value: selectedCompany?.value, label: selectedCompany?.label }}
            options={[{
              value: '', label: 'Selecione uma Empresa'
            }, ...companiesOptions]}
            onChange={(opt) => {
              setSelectedCompany({ value: opt!.value, label: opt!.label });
            }}
            styles={CustomStyle}
            classNamePrefix="react-select"
            className="react-select-container"
          />
        </Group>
      </>,
    23:
        <>
        </>,
  }), [selectedCompany.value, selectedCompany?.label, companiesOptions, selectedReport.value, generatedConsultsReportType, selectedTheme, handleSpecificPeriodChange, specificPeriod, specificPeriodLabel, selectedFileType, filesBySelectedFileType, selectedFile, handleSpecificPeriodChangeMrReport, periodBeingSelected.year, periodBeingSelected.month, currentYear, months, fileOptions, isCustomer, selectedPartner, partnersOptions, preAdmFilesOptions, baseFilesOptions, setSelectedCompany, setSelectedFileType, setSelectedFile, setPeriodBeingSelected, currentMonth, monthsMap, handleSelectedFileChange, setGeneratedConsultsReportType, setSelectedPartner]);

  return (
    <MyModal
      show={downloadModalShow}
      title="Download Relatórios Gerais"
      minHeight='450px'
      modalBody={(
        <ModalContainer>
          <OpacityAnimation delay={0.1}>
            <Group>
              <div className="title">
                Selecione um Relatório
              </div>
              <Select
                value={{ value: selectedReport?.value, label: selectedReport?.label }}
                options={[{
                  value: 0, label: 'Selecione um Relatório'
                }, ...reportOptions]}
                onChange={(opt) => {
                  setSelectedReport({ value: opt!.value, label: opt!.label });
                }}
                styles={CustomStyle}
                classNamePrefix="react-select"
                className="react-select-container"
              />
            </Group>

            {jsxBySelectedReport[selectedReport.value]}
          </OpacityAnimation>
        </ModalContainer>
      )}
      type="action"
      closeButtonLabel="Fechar"
      actionButtonLabel="Baixar"
      onClose={() => setDownloadModalShow(false)}
      onAction={() => downloadReport()}
      isActionButtonDisabled={!canDownloadReport[selectedReport.value]}
    />
  );
}
